/**
 * Stub for web: react-native-config does not run in the browser.
 */
const e = typeof process !== 'undefined' && process.env ? process.env : {};

module.exports = {
  ENVIRONMENT: e.ENV ?? '',
  FIREBASE_CLOUD_FUNCTION_URL: e.FIREBASE_CLOUD_FUNCTION_URL ?? '',
  PICTURE_URL: e.PICTURE_URL ?? '',
  PIN_URL: e.PIN_URL ?? '',
};
